export function divideEmail(email: string | null): string | null {
  if (email != null && email.length > 30) {
    let emailSplited = email.split("@");

    return emailSplited[0] + "\n @" + emailSplited[1];
  }
  return email;
}
